import React from "react";
import PropTypes from "prop-types";
import { Carousel } from 'react-responsive-carousel';
import SiniaCustomChart from "../../components/charts/sinia-custom-chart.component";
import ProgressBar from "components/progress-bar/progress-bar.component";
import { DataService } from "../../services/data.service";
import ChartUtils from "../../commons/chart-utils.module";
import IndicadoresAmbientales from "../../commons/indicadores.module";
import Ubigeo from "../../commons/ubigeo.module";
const NUM_INDICADORES_A_CARGAR = false;
class BloqueGraficos extends React.Component {
  static propTypes = {
    idRegion: PropTypes.string,
    idTematica: PropTypes.string,
    inlineCharts: PropTypes.number
  };
  static defaultProps = {
    inlineCharts: 12
  };
  constructor(props) {
    super(props);
    let me = this;
    me.chartRefs = {};
    me.indicadores = [];
    me.lastIdTematica = me.props.idTematica;
    me.loadingMode = true;
  }
  cargarIndicadores(idTematica) {
    this.indicadores = IndicadoresAmbientales.getIdsIndicadoresPorTematica(
      idTematica,
      NUM_INDICADORES_A_CARGAR
    );
    this.noDataToShow = !this.indicadores.length;
  }
  crearReferencias() {
    let me = this;
    me.indicadores.forEach(idIndicador => {
      let refId = "ref" + idIndicador;
      if (!me.chartRefs[refId]) {
        me.chartRefs[refId] = React.createRef();
      }
    });
  }
  componentDidMount() {
  }
  componentDidUpdate(prevProps) {
    let me = this,
      props = this.props;
    if (
      prevProps.idRegion !== props.idRegion ||
      prevProps.idTematica !== props.idTematica ||
      prevProps.availableStore!==props.availableStore
    ) {
      me.cargarDatos();
    }
  }
  cargarDatos() {
    let me = this,
      props = me.props;
    me.indicadores.forEach(idIndicador => {
      me._cargarDatosDeGrafico(idIndicador, props.idRegion, props.idTematica);
    });
  }
  render() {
    let me = this;
    me.cargarIndicadores(me.props.idTematica);
    me.crearReferencias();
    if (me.noDataToShow) {
      return me.renderNoData();
    }
    return (
      <div>
        <Carousel className="col">
          {me.indicadores.map(function (idIndicador) {
            return me.renderChart(idIndicador);
          })}
        </Carousel>
      </div>
    );
  }
  renderNoData() {
    return (
      <div className="alert alert-info sinia-message" role="alert">
        Lo sentimos, no disponemos de información sobre la temática
        seleccionada.
      </div>
    );
  }
  /**
   * Es renderizado cuando los datos están cargando
   */
  renderLoading() {
    return <ProgressBar active={true} />;
  }
  /**
   *
   * @param {string} idIndicador
   * @param {RefObject} referencia
   */
  renderChart(idIndicador, type = "column") {
    let titleTpl = `${IndicadoresAmbientales.getNombre(
      idIndicador
    )}`;
    let { inlineCharts } = this.props;
    return (
      <div key={idIndicador}>
        <SiniaCustomChart 
          exportable={true}
          key={idIndicador}
          chartType={type}
          titleTpl={titleTpl}
          yAxeTitle={IndicadoresAmbientales.getUnidad(idIndicador)}
          seriesLabel={IndicadoresAmbientales.getUnidad(idIndicador)}
          xAxeTitle="Años"
          source={`Fuente: ${IndicadoresAmbientales.getFuenteAbrev(
            idIndicador
          )}`}
          ref={this.chartRefs["ref" + idIndicador]}
        />
      </div>
    );
  }
  _cargarDatosDeGrafico(idIndicador, idRegion, idTematica) {
    var me = this;
    if(IndicadoresAmbientales.getSerie(idIndicador, idRegion)){
      DataService.getData(
        {
          query: "SNA08",
          ubigeo: idRegion,
          marco: idTematica,
          serie: IndicadoresAmbientales.getSerie(idIndicador, idRegion)
        },
        function (data) {
          if (data.SNA08.data && data.SNA08.data[0] && data.SNA08.data[0].valor) {
            me.formatServerResponseDataAndUpateCharts(
              idIndicador,
              data.SNA08.data
            );
          } else {
            me.formatServerResponseDataAndUpateCharts(idIndicador, []);
          }
        }
      );
    }
  }

  /**
   * Formatear respuesta del servidor y actualizar gráficos.
   *
   * @param {string|number} idIndicador
   * @param {array} rawData Datos en formato de respuesta del servidor
   * Ejm:
   * [
   *   {periodo: 2010, ubigeo: '25', valor: 2587, nombre: 'Ucayali'},
   *   ...
   * ]
   */
  formatServerResponseDataAndUpateCharts(idIndicador, rawData) {
    let me = this,
      data = ChartUtils.formatYearlyDataForChart(rawData);
    me.actualizarDatosDeGrafico(me.getChart(idIndicador), idIndicador, data);
  }
  getChart(idIndicador) {
    return this.chartRefs["ref" + idIndicador].current;
  }
  /**
   *
   * @param {SiniaCustomChart} chart
   * @param {Object} datos
   * @param {Array} data.valores
   * @param {Array} data.categorias
   */
  actualizarDatosDeGrafico(chart, idIndicador, datos) {
    if (!chart) {
      return;
    }
    chart.actualizarDatos(datos.valores, datos.categorias, {
      region: Ubigeo.getNombreRegion(this.props.idRegion),
      anioInicio: datos.anioInicio,
      anioFin: datos.anioFin,
      unidad: IndicadoresAmbientales.getUnidad(idIndicador)
    });
  }
}
export default BloqueGraficos;
